import { styled } from 'stitches.config'

export const OwnPaceRoot = styled('section', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  color: '$accent-white',
  gap: '$3',
  maxWidth: '440px',
  '@bp2': {
    gap: '$4',
    maxWidth: '1300px',
  }
})

export const Header = styled('h2', {
  fontSize: '$h2',

  '@bp2': {
    fontSize: '$h1',
  }
})

export const Subheader = styled('h3', {
  fontSize: '$h3'
})